import {
  createContext,
  useState,
  useCallback,
  useMemo,
  useContext,
} from "react";

export const themes = {
  dark: "dark",
  light: "light",
};

export const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

export const useThemeColors = () => {
  const { theme, oppositeTheme } = useContext(ThemeContext);
  return { theme, oppositeTheme };
};

export const ThemeProvider = ({ children }) => {
  const isDarkThemePreferred = window.matchMedia(
    "(prefers-color-scheme: dark)"
  ).matches;

  const [theme, setTheme] = useState(
    localStorage.getItem("themeMode") ||
      (isDarkThemePreferred ? themes.dark : themes.light)
  );

  const toggleTheme = useCallback(() => {
    const newThemeValue = theme === themes.dark ? themes.light : themes.dark;
    setTheme(newThemeValue);
    localStorage.setItem("themeMode", newThemeValue);
  }, [theme, setTheme]);

  const oppositeTheme = useMemo(
    () => (theme === themes.dark ? themes.light : themes.dark),
    [theme]
  );

  const value = useMemo(
    () => ({ theme, oppositeTheme, toggleTheme }),
    [theme, oppositeTheme, toggleTheme]
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};
